import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {StyleType} from "@catui/types";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Service, Unit} from "@catmodels/units/types";
import {GenericResourceService} from "@catfeatures/services/generic-resource.service";
import {NotificationsService} from "@catcore/services";
import {ActiveModal} from "@catmodules/widgets/slide-in-modal/utils/modal-ref";
import {EntitySchemaService} from "@catcore/services/entity-schema.service";
import {EntitySchemaType} from "@catcore/utils/json-schema/entity-schema-to-json-schema";
import {buildFormControlsFromSchema} from "@catuiform/shared/form-builder";

@Component({
  selector: 'catapp-modify-ggw-dev-zone-assignment',
  templateUrl: './modify-ggw-dev-zone-assignment.component.html',
  styleUrls: ['./modify-ggw-dev-zone-assignment.component.scss']
})
export class ModifyGgwDevZoneAssignmentComponent implements OnInit {

  styleType = StyleType;
  form: FormGroup;
  @Output() afterUpdate = new EventEmitter<any>();

  private _zoneAssignment: any;
  private modelSchema;

  constructor(private formBuilder: FormBuilder,
              private resourceService: GenericResourceService,
              private notification: NotificationsService,
              private activeModal: ActiveModal,
              schemaService: EntitySchemaService) {
    this.modelSchema = schemaService.getForEntityName(EntitySchemaType['GgwDeviceZoneAssignments']);
    const formControls = buildFormControlsFromSchema(this.formBuilder, this.modelSchema);
    this.form = this.formBuilder.group(formControls);
  }

  @Input()
  get zoneAssignment(): any {
    return this._zoneAssignment;
  }

  set zoneAssignment(value: any) {
    this._zoneAssignment = value;
    if (this._zoneAssignment) {
      this.form.patchValue(this._zoneAssignment);
      this.form.patchValue({
        ggw_device: this._zoneAssignment._links.ggw_device.href,
        gui_zone: this._zoneAssignment._links.gui_zone.href,
      });
      Object.keys(this.modelSchema.properties).forEach((prop) => {
        if (this.modelSchema.properties[prop].type === 'array') {
          this.updateFormArray(this.form.get(prop), value[prop]);
        }
      });
    }
  }

  onSubmit() {
    const formValue = this.form.value;
    const create = (formValue.id === null);
    const service = this.resourceService.findServiceForResource(create
      ? this.modelSchema.resourceUri
      : this._zoneAssignment._links.self.href);

    const subscr = service
      .save(this.form.value, create)
      .finally(() => subscr.unsubscribe())
      .subscribe((res) => {
        this.notification.success('Update successful', 'Zone assignment details have been saved.');
        this.activeModal.close();
        this.afterUpdate.emit(res);
      });
  }

  ngOnInit() {
  }

  private updateFormArray(formArray, values) {
    while (formArray.length > 0) {
      formArray.removeAt(0);
    }
    values.forEach((val) => {
      formArray.push(new FormControl(val, [Validators.required]));
    });
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/ggw-dev-zone-assignment/components/modify-ggw-dev-zone-assignment/modify-ggw-dev-zone-assignment.component.ts